"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-arrow-back.tsx
var ArrowBack = function ArrowBack(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
  }));
};

var _default = ArrowBack;
exports.default = _default;